<template>
    <button :type="c_type" :class="c_css" class="btn rounded-sm position-relative" :disabled="c_disabled" @click="clicked"> 
        <div v-show="c_disabled" :class="c_spinner" class="spinner-grow spinner-grow-sm spinner-styles" role="status">...
            <span class="sr-only">Loading...</span>
        </div>
        <div :class="{ invisible: c_disabled }">
            <slot></slot>
        </div>
        
    </button>
</template>

<script>
export default {
    props: ['type','css','loading','variant','emt','spinner','disabled'],
    computed: {
        c_type() {
            return  typeof this.type !== 'undefined' ? this.type : 'button';
        },
        c_variant() {
            return  typeof this.variant !== 'undefined' ? ' btn-' + this.variant : ' btn-primary';
        },
        c_css() {
            var css = typeof this.css !== 'undefined' ? this.css : '';
            return css + this.c_variant;
        },
        c_spinner() {
            return typeof this.variant !== 'undefined' ? this.variant : 'text-light'
        },
        c_disabled() {
            
            var loading = typeof this.loading !== 'undefined' ? this.loading : this.$parent.loading;

            if (loading) return true;

            if (this.disable) return true;

            return false;

        }
    },
    methods: {
        clicked() {
            if (!this.c_disabled) {
                if (typeof this.emt === 'string') {
                    this.$emit(this.emt)
                } else if (typeof this.emt === 'object') {
                    this.$emit(this.emt.evt,this.emt.data)
                } else {
                    this.$emit('click');
                }
            }
        }
    }
}
</script>

<style scoped>
.spinner-styles {
    margin-bottom: 3px !important;
    position: absolute;
    width: 16px !important;
    height: 16px;
    left: calc(50% - 8px);
    top: 8px;
}
</style>